import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  removeEmailStatus,
  saveNewEmailAsync,
  sendOtpEmailAsync,
} from "../../features/userSlice";
import OTPInput from "otp-input-react";

const ResetEmailModal = ({ vals }) => {
  const { show, setShow, setModal } = vals;

  const [email, setEmail] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState({});

  const [otpShow, setOtpShow] = useState(false);
  const dispatch = useDispatch();

  const [OTP, setOTP] = useState("");
  const [btnValue, setBtnValue] = useState("Send OTP");

  const emailRef = React.useRef(null);

  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};

  const resetEmailStatus = useSelector(
    (state) => state.user.resetEmailStatus,
    shallowEqual
  );

  const validate = () => {
    let error = {};
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
    if (email === "") {
      error.email = "Email Is Required!";
    } else if (!emailRegex.test(email)) {
      error.email = "Please Enter A Valid Email!";
    }

    if (btnValue === "Verify") {
      if (OTP.length !== 4) {
        error.otp = "Add 4 digit code";
      }
    }

    return error;
  };

  useEffect(() => {
    if (Object.keys(error).length === 0 && isSubmit) {
      if (btnValue === "Send OTP") {
        dispatch(sendOtpEmailAsync({ email, Authorization }));
      } else {
        dispatch(saveNewEmailAsync({ email, OTP, Authorization }));
        setShow(false);
        setOtpShow(false);
        dispatch(removeEmailStatus());
        setBtnValue("Send OTP");
      }
      setIsSubmit(false);
    }
  }, [error, isSubmit]);

  useEffect(() => {
    if (resetEmailStatus === true) {
      setOtpShow(true);
      emailRef.current.disabled = true;
      setBtnValue("Verify");
    }
  }, [resetEmailStatus]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(validate());
    setIsSubmit(true);
  };

  return (
    <>
      <div
        className={`modal my-auto ${show ? "d-flex" : "d-none"}`}
        id="reset-password-Modal"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <form action="" className="cmn-form login-form">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setOtpShow(false);
                    setShow(false);
                    dispatch(removeEmailStatus());
                    setBtnValue("Send OTP");
                  }}
                ></button>

                <div className="form-title">
                  <h2>Reset Email</h2>
                </div>
                <div className="form-group">
                  <label htmlFor="reset">Email Address</label>
                  <input
                    type="text"
                    id="reset"
                    placeholder="Enter Email"
                    autoComplete="off"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    ref={emailRef}
                    onBlur={() => {
                      setError(validate());
                    }}
                    // onFocus={(e) => {
                    //   setError({});
                    //   setIsSubmit(false);
                    // }}
                  />
                  <p className="text-danger">{error?.email}</p>
                </div>

                <div className={`form-group ${otpShow ? "d-block" : "d-none"}`}>
                  <label htmlFor="" className="">
                    Enter OTP
                  </label>
                  <div className="change-password-otp">
                    <OTPInput
                      value={OTP}
                      onChange={setOTP}
                      autoFocus
                      OTPLength={4}
                      otpType="number"
                      disabled={false}
                      secure
                      onBlur={() => {
                        setError(validate());
                      }}
                    />
                  </div>

                  <p className="not-recive text-end">
                    Didn't Recive OTP?{" "}
                    <span
                      onClick={() =>
                        dispatch(sendOtpEmailAsync({ email, Authorization }))
                      }
                    >
                      ResendOTP
                    </span>{" "}
                  </p>
                </div>
                <p className="text-danger">{error?.otp}</p>

                <div className="form-group">
                  <input
                    type="submit"
                    className="cmn-btn form-btn"
                    value={btnValue}
                    onClick={handleSubmit}
                  />
                </div>
              </form>
              {/*  */}

              {/*  */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetEmailModal;
